module.exports = __webpack_public_path__ + "img/media_card_background.21743314.png";